import { render, staticRenderFns } from "./affix.vue?vue&type=template&id=6544ad05&scoped=true&"
import script from "./affix.vue?vue&type=script&lang=js&"
export * from "./affix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6544ad05",
  null
  
)

export default component.exports